// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { FaPlus, FaEye } from "react-icons/fa";
// import { Modal, Button, Form, Table, Pagination, Row, Col, Container, Spinner } from "react-bootstrap";
// import { FaEdit } from "react-icons/fa";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { BsThreeDots } from "react-icons/bs";

// const API_URL = process.env.REACT_APP_API_URL;

// function VisteByDate() {
//     const { date } = useParams();
//     const navigate = useNavigate();
//     const [expenses, setExpenses] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [dataLoading, setDataLoading] = useState(true);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const getAuthToken = () => {
//         return localStorage.getItem("token");
//     };
//     const fetchExpenses = async (page = 1) => {
//         const token = getAuthToken();
//         if (!token) {
//             setLoading(false);
//             setDataLoading(false);
//             return;
//         }

//         setLoading(true);
//         try {
//             const response = await fetch(`${API_URL}/visite-dateWaise-view?date=${date}&page=${page}&limit=10`, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             });
//             if (!response.ok) {
//                 throw new Error("Failed to fetch expenses.");
//             }
//             const data = await response.json();
//             console.warn(data);
//             if (data.success == "1") {
//                 setExpenses(data.data);
//                 setTotalPages(data.totalPages || 1);
//                 setCurrentPage(data.currentPage || page);
//             } else {
//                 alert("Error", data.message, "error");
//             }
//         } catch (error) {
//             console.error("Failed to fetch expenses:", error);

//         } finally {
//             setLoading(false);
//             setDataLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchExpenses(currentPage);
//     }, []);

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber > 0 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//             fetchExpenses(pageNumber);
//         }
//     };



//     return (
//         <Container fluid>
//             <div className="card">
//                 <div className="card-header">
//                     <div className="d-flex justify-content-between align-items-center">
//                         <div className="titlepage">

//                             <h3 className="mb-0">Visit By Date Report</h3>
//                         </div>
//                         <Link to="/visit-date-wise" className="btn btn-primary">
//                             Back
//                         </Link>

//                     </div>
//                 </div>
//                 <div className="card-body">
//                     <Row className="mt-4">
//                         <Col>
//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                 <h2></h2>

//                             </div>

//                             {dataLoading ? (
//                                 <div className="text-center p-5">
//                                     <Spinner animation="border" />
//                                     <p className="mt-2">Loading expenses...</p>
//                                 </div>
//                             ) : (
//                                 <>
//                                     <Table striped bordered hover responsive className="shadow-sm">
//                                         <thead>
//                                             <tr>
//                                                 <th>#</th>
//                                                 <th>Name</th>
//                                                 <th>Mobile</th>
//                                                 <th>Start Time</th>
//                                                 <th>Start Address</th>
//                                                 <th>End Time</th>
//                                                 <th>End Address</th>
//                                                 <th>Distance(Meter)</th>
//                                                 <th>Per KM Amount</th>
//                                                 <th>Total Amount</th>
//                                                 <th>Status</th>

//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {expenses.length > 0 ? (
//                                                 expenses.map((expense, index) => (
//                                                     <tr key={expense.id}>
//                                                         {/* Corrected serial number - shows 1-10 on page 1, 11-20 on page 2, etc. */}
//                                                         <td>{(currentPage - 1) * 10 + index + 1}</td>
//                                                         <td>{expense.user_name}</td>
//                                                         <td>{expense.mobile}</td>
//                                                         <td>
//                                                             {new Date(expense.start_time).toLocaleString('en-US', {
//                                                                 year: 'numeric',
//                                                                 month: 'short',
//                                                                 day: 'numeric',
//                                                                 hour: 'numeric',
//                                                                 minute: '2-digit',
//                                                                 second: '2-digit',
//                                                                 hour12: true
//                                                             })}
//                                                         </td>
//                                                         <td>{expense.start_address}</td>
//                                                         <td>
//                                                             {new Date(expense.end_time).toLocaleString('en-US', {
//                                                                 year: 'numeric',
//                                                                 month: 'short',
//                                                                 day: 'numeric',
//                                                                 hour: 'numeric',
//                                                                 minute: '2-digit',
//                                                                 second: '2-digit',
//                                                                 hour12: true
//                                                             })}
//                                                         </td>
//                                                         <td>{expense.end_address}</td>
//                                                         <td>{expense.distance}</td>
//                                                  <td>
//   &#8377; {Number(expense.per_kilometer_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
// </td>
//                                                      <td>
//   &#8377; {Number(expense.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
// </td>
//                                                         <td style={{
//                                                             color: expense.status === 'end' ? 'green' : expense.status === 'start' ? 'red' : 'inherit'
//                                                         }}>
//                                                             {expense.status.toUpperCase()} 
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td colSpan="11" className="text-center">No Visit found.</td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </Table>

//                                     <div className="d-flex justify-content-end">
//                                         <nav>
//                                             <ul className="pagination">
//                                                 <li className="page-item">
//                                                     <button
//                                                         className="page-link"
//                                                         onClick={() => handlePageChange(currentPage - 1)}
//                                                         disabled={currentPage === 1}
//                                                         aria-label="Previous"
//                                                     >
//                                                         <HiOutlineChevronLeft />
//                                                     </button>
//                                                 </li>

//                                                 {[...Array(totalPages)].map((_, index) => (
//                                                     <li key={index + 1} className="page-item">
//                                                         <button
//                                                             className={`page-link ${index + 1 === currentPage ? "active" : ""}`}
//                                                             onClick={() => handlePageChange(index + 1)}
//                                                         >
//                                                             {index + 1}
//                                                         </button>
//                                                     </li>
//                                                 ))}

//                                                 <li className="page-item">
//                                                     <button
//                                                         className="page-link"
//                                                         onClick={() => handlePageChange(currentPage + 1)}
//                                                         disabled={currentPage === totalPages}
//                                                         aria-label="Next"
//                                                     >
//                                                         <HiChevronRight />
//                                                     </button>
//                                                 </li>
//                                             </ul>
//                                         </nav>
//                                     </div>
//                                 </>
//                             )}
//                         </Col>
//                     </Row>
//                 </div>
//             </div>

//         </Container>
//     );
// }

// export default VisteByDate;
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

function VisteByDate() {
  const { date } = useParams();
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limit = 10;

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH VISITS BY DATE
  // ═══════════════════════════════════════════
  const fetchExpenses = async (page = 1) => {
    const token = getAuthToken();
    if (!token) {
      setLoading(false);
      setDataLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${API_URL}/visite-dateWaise-view?date=${date}&page=${page}&limit=${limit}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch visits.");
      }
      const data = await response.json();
      if (data.success == "1") {
        setExpenses(data.data || []);
        setTotalPages(data.totalPages || 1);
        setCurrentPage(data.currentPage || page);
        setTotalItems(data.total || data.data?.length || 0);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Failed to fetch visits:", error);
    } finally {
      setLoading(false);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      fetchExpenses(pageNumber);
    }
  };

  // ─── Format date for display in header ───
  const getFormattedHeaderDate = () => {
    if (!date) return "";
    const parts = date.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${day}-${month}-${year}`;
    }
    return date;
  };

  // ─── Pagination numbers ───
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;
    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    if (showEllipsis && currentPage < totalPages - 3)
      pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
          {/* ═══════ HEADER CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              padding: "24px 30px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                background:
                  "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "26px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🚶
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Visit By Date Report
              </h1>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "6px",
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    background:
                      "linear-gradient(135deg, #e8f1fb, #dbeafe)",
                    color: "#1e5799",
                    fontSize: "12px",
                    fontWeight: "700",
                    border: "1.5px solid #bfdbfe",
                  }}
                >
                  📅 {getFormattedHeaderDate()}
                </span>
                <span
                  style={{
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  {totalItems} total records
                </span>
              </div>
            </div>

            <button
              type="button"
              onClick={() => navigate("/visit-date-wise")}
              style={{
                padding: "10px 20px",
                borderRadius: "10px",
                border: "1.5px solid #e2e8f0",
                background: "#ffffff",
                color: "#1e5799",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 8px rgba(30, 87, 153, 0.06)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#f0f6ff";
                e.currentTarget.style.borderColor = "#1e5799";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#ffffff";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              ← Back
            </button>
          </div>

          {/* ═══════ MAIN CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px 30px" }}>
              {dataLoading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "70px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      border: "3px solid #cbd5e1",
                      borderTop: "3px solid #2b6cb0",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "18px",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Loading visits...
                  </p>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      overflowX: "auto",
                      overflowY: "visible",
                      borderRadius: "14px",
                      border: "1.5px solid #e2e8f0",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        minWidth: "1400px",
                        borderCollapse: "collapse",
                        fontSize: "12.5px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          }}
                        >
                          {[
                            "S.N",
                            "Name",
                            "Mobile",
                            "Start Time",
                            "Start Address",
                            "End Time",
                            "End Address",
                            "Distance (m)",
                            "Per KM",
                            "Total Amount",
                            "Status",
                          ].map((th, i) => (
                            <th
                              key={i}
                              style={{
                                padding: "14px 12px",
                                color: "#ffffff",
                                fontWeight: "700",
                                fontSize: "11px",
                                textAlign: "left",
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {th}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {expenses.length > 0 ? (
                          expenses.map((expense, index) => (
                            <tr
                              key={expense.id}
                              style={{ borderBottom: "1px solid #f1f5f9" }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background =
                                  "#f8fafc")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background =
                                  "transparent")
                              }
                            >
                              <td
                                style={{
                                  padding: "12px",
                                  fontWeight: "700",
                                  color: "#1e5799",
                                }}
                              >
                                {(currentPage - 1) * limit + (index + 1)}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  fontWeight: "600",
                                  color: "#1e3a5f",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {expense.user_name || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#334155",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {expense.mobile || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {new Date(expense.start_time).toLocaleString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  }
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  maxWidth: "220px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  lineHeight: "1.5",
                                }}
                              >
                                {expense.start_address || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {new Date(expense.end_time).toLocaleString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  }
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  maxWidth: "220px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  lineHeight: "1.5",
                                }}
                              >
                                {expense.end_address || "-"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "11px",
                                    fontWeight: "700",
                                    background: "#e8f1fb",
                                    color: "#1e5799",
                                  }}
                                >
                                  {expense.distance || "0"} m
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#334155",
                                  fontWeight: "600",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                ₹{" "}
                                {Number(
                                  expense.per_kilometer_amount
                                ).toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                })}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "5px 12px",
                                    borderRadius: "8px",
                                    background:
                                      "linear-gradient(135deg, #f0fdf4, #dcfce7)",
                                    color: "#059669",
                                    fontWeight: "800",
                                    fontSize: "12.5px",
                                    border: "1.5px solid #86efac",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  ₹{" "}
                                  {Number(expense.amount).toLocaleString(
                                    "en-IN",
                                    { minimumFractionDigits: 2 }
                                  )}
                                </span>
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "5px 12px",
                                    borderRadius: "20px",
                                    fontSize: "11px",
                                    fontWeight: "800",
                                    textTransform: "uppercase",
                                    background:
                                      expense.status === "end"
                                        ? "#e7f9eb"
                                        : expense.status === "start"
                                          ? "#feeaeb"
                                          : "#f1f5f9",
                                    color:
                                      expense.status === "end"
                                        ? "#059669"
                                        : expense.status === "start"
                                          ? "#dc2626"
                                          : "#64748b",
                                  }}
                                >
                                  {expense.status
                                    ? expense.status.toUpperCase()
                                    : "-"}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="11"
                              style={{
                                textAlign: "center",
                                padding: "60px 20px",
                                color: "#94a3b8",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              📭 No Visit found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* ═══════ PAGINATION ═══════ */}
                  {totalPages > 1 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "24px",
                        gap: "6px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            currentPage === 1 ? "#cbd5e1" : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === 1 ? "not-allowed" : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        ‹ Prev
                      </button>

                      {getPageNumbers().map((p, i) => {
                        if (
                          p === "left-ellipsis" ||
                          p === "right-ellipsis"
                        ) {
                          return (
                            <span
                              key={`ellipsis-${i}`}
                              style={{
                                padding: "0 6px",
                                color: "#94a3b8",
                                fontWeight: "700",
                              }}
                            >
                              ...
                            </span>
                          );
                        }
                        const isActive = p === currentPage;
                        return (
                          <button
                            key={p}
                            onClick={() => handlePageChange(p)}
                            style={{
                              minWidth: "38px",
                              height: "38px",
                              borderRadius: "10px",
                              border: isActive
                                ? "none"
                                : "1.5px solid #e2e8f0",
                              background: isActive
                                ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                : "#ffffff",
                              color: isActive ? "#ffffff" : "#334155",
                              fontWeight: "700",
                              fontSize: "13px",
                              cursor: "pointer",
                              boxShadow: isActive
                                ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                                : "none",
                              transition: "all 0.18s ease",
                            }}
                          >
                            {p}
                          </button>
                        );
                      })}

                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            currentPage === totalPages
                              ? "#cbd5e1"
                              : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === totalPages
                              ? "not-allowed"
                              : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        Next ›
                      </button>
                    </div>
                  )}

                  {expenses.length > 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#94a3b8",
                        marginTop: "12px",
                        marginBottom: 0,
                        fontWeight: "500",
                      }}
                    >
                      Page {currentPage} of {totalPages} • {totalItems} total
                      records
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default VisteByDate;